import { graphql, useStaticQuery } from "gatsby";

export const useCategories = type => {
    const { allContentfulCategorySection: data } = useStaticQuery(graphql`
        query departments {
            allContentfulCategorySection(
                filter: {
                    categories: { elemMatch: { published: { eq: true } } }
                }
                sort: { index: ASC }
            ) {
                nodes {
                    name
                    type
                    categories {
                        title
                        description {
                            raw
                        }
                        url
                        published
                    }
                }
            }
        }
    `);

    return data?.nodes?.filter(section => section.type === type);
};
